import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import { Tooltip } from "@material-ui/core"

const EstatusVoucher = ({ estatus = true }) => {
    if (estatus) return (
        <Tooltip title="Cargado">
            <CheckCircleIcon color='secondary' />
        </Tooltip>
    )
    return (
        <Tooltip title="Pendiente de cargar el voucher">
            <ErrorIcon style={{ color: "#B89130" }} />
        </Tooltip>
    )
}
export default EstatusVoucher